import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { FleeingButterflyAnimation } from '../../animations/FleeingButterflyAnimation';

// types
//-----------------------------------------------------------------------------
export type ButterflyEffectOptions = {
  position: PositionType;
  scale: number;
  rotation: number;
};

/*
    butterfly fleeing effect
*/
export class ButterflyEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _scale: number;
  private readonly _rotation: number;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: ButterflyEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._scale = options.scale;
    this._rotation = options.rotation;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new FleeingButterflyAnimation({
      scale: this._scale,
      rotation: this._rotation,
    });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
